import { j as e } from "../../../../node_modules/react/jsx-runtime.js";
import { Typography as t } from "../../../atoms/Typography/Typography.js";
import o from "../../../atoms/Icon/Icon.js";
import { i18n as r } from "../../../../utils/locale/locale.js";
const n = () => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("div", { className: "h-[200px] flex flex-col gap-150 justify-center items-center", children: [
  /* @__PURE__ */ e.jsx(
    o,
    {
      name: "file-search-02",
      size: "md",
      color: "#9AA4B2",
      "data-testid": "icon"
    }
  ),
  /* @__PURE__ */ e.jsx(
    t,
    {
      variant: "interface/medium/sm",
      text: r("no_results_found"),
      textColor: "color/fg/lightest"
    }
  )
] }) });
export {
  n as default
};
//# sourceMappingURL=NoResultMessage.js.map
